export const breakpoints = {
  desktop: 1440,
  tablet: 1152, // Design team did not define a final value yet.
  mobile: 480
}
